import $ from 'jquery';
import Swiper from 'swiper';
import { config, dom, library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle, faSortDown, faCheck, faChevronUp, faAngleDown, faAngleLeft, faAngleRight, faWifi, faMapMarkerAlt, faPencilAlt, faBars, faChevronRight, faCaretDown, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
library.add(faSortDown, faCheck, faChevronUp, faAngleDown, faAngleLeft, faAngleRight, faWifi, faMapMarkerAlt, faQuestionCircle, faPencilAlt, faBars, faChevronRight, faCaretDown, faCaretLeft);
dom.watch();
import "../../node_modules/bootstrap-reboot/dist/reboot.min.css";
import "../scss/bundle.scss";
import "../scss/main.scss";
import "../../node_modules/swiper/css/swiper.min.css";


let swipeOption = {
  loop: true,
  effect: 'fade',
  autoHeight: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
  speed: 3000,
}
new Swiper('.swiper-container', swipeOption);

$(function () {
  var boxTop = new Array;
  var current = -1;
  let titleId = null;
  const headerPosition = $("#js-header-wifi").offset().top;
  const $Btn = $("#js-menu-btn");
  const $Nav = $("#js-menu-nav");
  const $Back = $("#js-back");
  const maxWidth = $(window).width();

  (function () {
    headerFixed();
    $Btn.removeClass("s-open");
    $Nav.removeClass("s-open");
    $Back.removeClass("s-open");
  }())

  //特定の高さでheaderにfixedを追加するクラスを付与
  function headerFixed() {
    let position = $(window).scrollTop();
    if ($("#js-header-wifi").length) {
      if (position >= headerPosition - 100) {
        if ($("#js-header-wifi").hasClass("s-fixed") == false) {
          $("#js-header-wifi").addClass("s-fixed");
        }
      } else {
        $("#js-header-wifi").removeClass("s-fixed");
      }
    }
  }

  //headerのカレントスタイルを付与する
  function changeBox(secId) {
    if (secId != current) {
      current = secId;
      $(".m-header .menu .menu-item").removeClass("s-current");
      if ($(".s-" + secId).length) {
        $(".s-" + secId).addClass("s-current");
      }
    }
  };

  //headerの開閉のクラスを付与
  function setOpenMenuClass() {
    if ($Btn.hasClass("s-open") && $Nav.hasClass("s-open")) {
      $Btn.removeClass("s-open");
      $Back.removeClass("s-open");
      $Nav.removeClass("s-open");
    } else {
      $Btn.addClass("s-open");
      $Nav.addClass("s-open");
      $Back.addClass("s-open");
    }
    return false;
  }

  //各セクションのタイトルからセクションのidと高さを取得
  $('.js-section_title').each(function (i) {
    titleId = $(this).attr("id")
    boxTop[i] = {
      id: titleId,
      section: $("#js-" + titleId).offset().top
    }
  });

  //headerのメニューカレント
  $(window).on("scroll", function () {
    let scrollPosition = $(window).scrollTop();
    if (768 >= maxWidth) {
      var set = -70;
    } else {
      var set = -120;
    }

    for (var i = boxTop.length - 1; i >= 0; i--) {
      if ($(window).scrollTop() > boxTop[i].section + set) {
        changeBox(boxTop[i].id);
        break;
      }
    };
    headerFixed();
  });

  //メニュー開閉ボタンの切り替え
  if ($("#js-menu-btn").length && $("#js-menu-nav").length) {
    //クリック時の処理
    $("#js-menu-btn").on("click", function () {
      setOpenMenuClass();
    });

    //背景クリック時の処理
    if (1024 >= maxWidth && $("#js-back").length){
      $("#js-back").on("click", function () {
        setOpenMenuClass();
      });
    }

    //リンククリック時の処理
    if (1024 >= maxWidth && $(".menu-item a").length) {
      $(".menu-item a").on("click", function () {
        setOpenMenuClass();
      });
    }

    //open時にスクロールした時の処理
    $(window).on("scroll", function () {
      if ($("#js-menu-btn.s-open").length) {
        setOpenMenuClass();
      }
    });
  }

  //スムーズスクロール
  $('a[href^="#"]').click(function () {
    if (768 >= maxWidth) {
      var adjust = -60;
    } else {
      var adjust = -110;
    }
    var speed = 500;
    var href = $(this).attr("href");
    if (href == "#" || href == "") {
      var target = $('html');
    } else {
      var target = $(href == "#" ? "#" : href.replace("#", "#js-"));
    }
    var position = target.offset().top + adjust;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

